// Pendências do follow-up do processo (backend: ProcessPending, api/process/{id}/pendings).
export const PENDING_STATUSES = ["Aguardando", "Impedimento", "Resolvida"] as const;
export type PendingStatus = (typeof PENDING_STATUSES)[number];

export interface ProcessPending {
  id: string;
  processId: string;
  description: string;
  status: PendingStatus | string;
  responsibleId?: string | null;
  responsibleName?: string | null;
  dueDate?: string | null;
  resolvedAt?: string | null;
  createdDate: string;
  isOpen: boolean;
}

export interface SaveProcessPendingCommand {
  description: string;
  status?: string;
  responsibleId?: string | null;
  dueDate?: string | null;
}
